export const globalWindow = window;
